import { getResData, httpClient } from "utils";

export const ALLOWED_VALUES = {
  DICTIONARY: `/dict`,
  SITES_BY_COUNTRY: (countryName: any) => `/dict/sites?country=${countryName}`,
  COUNTRY_BY_COUNTRY_REGION: (countryRegionName: any) => `/dict/countries?country_region=${countryRegionName}`
};

export interface UnitDescription {
  unit: string;
  description: string;
}

export interface UtilityType {
  allowedUnits: string[];
  id: number;
  name: string;
  unitDescription: UnitDescription[];
  ghgEmission: string;
}

export interface UtilityTypeWithUnitDescription {
  optional: boolean;
  subtypes: string[];
}

export interface UtilitySubtypesMap {
  [utilityType: string]: UtilityTypeWithUnitDescription;
}

export interface AllowedValuesDTO {
  billStatuses: string[];
  businessUnits: string[];
  countries: string[];
  currencies: string[];
  frequencies: string[];
  regions: string[];
  siteStatuses: string[];
  siteTypes: string[];
  units: string[];
  uploadTypes: string[];
  utilitySubtypesMap: UtilitySubtypesMap;
  utilityTypes: UtilityType[];
  countryRegions: string[];
  intensityCategories: string[];
  intensityAreaUnits: string[];
  siteAreaUnits: string[];
  sites: { siteId: number, siteName: string }[];
}

export const getAllowedValues = (): Promise<AllowedValuesDTO> =>
  httpClient.get<AllowedValuesDTO>(ALLOWED_VALUES.DICTIONARY).then(getResData);

export const getSitesByCountry = (name: any): Promise<any> =>
  httpClient.get<any>(ALLOWED_VALUES.SITES_BY_COUNTRY(name)).then(getResData);
